(function(){
  var BASE='https://cdn.shopify.com/s/files/1/0693/8463/4433/files/';
  var INTERVAL=4000, FADE=1100;
  function apply(img, names){
    if(!img || names.length<2) return;
    var wrap=img.parentElement;
    var srcs=wrap.querySelectorAll('source'); for(var s=0;s<srcs.length;s++){ srcs[s].parentNode.removeChild(srcs[s]); }
    if(getComputedStyle(wrap).position==='static') wrap.style.position='relative';
    if(getComputedStyle(wrap).display==='inline') wrap.style.display='block';
    img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src=BASE+names[0];
    img.style.transition='opacity '+FADE+'ms ease';
    var layers=[img];
    for(var i=1;i<names.length;i++){
      var im=document.createElement('img'); im.src=BASE+names[i]; im.alt='';
      im.style.position='absolute'; im.style.top='0'; im.style.left='0';
      im.style.width='100%'; im.style.height='100%'; im.style.objectFit='cover';
      im.style.opacity='0'; im.style.transition='opacity '+FADE+'ms ease';
      wrap.appendChild(im); layers.push(im);
    }
    var cur=0;
    setInterval(function(){ var n=(cur+1)%layers.length; layers[cur].style.opacity='0'; layers[n].style.opacity='1'; cur=n; }, INTERVAL);
  }
  function init(){
    var ok=document.querySelector('[id$="__okinawa-story"]');
    if(ok) apply(ok.querySelector('img'), ['rk-top-origin-1d.jpg','rk-top-origin-2b.jpg','rk-top-origin-3b.jpg']);
    var hero=document.querySelector('[id$="__slideshow"] .slideshow__slide img');
    if(hero) apply(hero, ['rk-top-hero-017.jpg','rk-top-hero-096.jpg','rk-top-hero-8744.jpg','rk-top-hero-8702.jpg']);
  }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

